import { Client } from "app/models/client";
import { User } from "./user";

export class UserSelf {

    public id: number;

    public name: string;

    public email: string;

    public client: Client;

    public accessData: User.AccessData;

    public role: User.Role;

    public permissions: User.Permissions;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/userSelf.ts